// extracted by mini-css-extract-plugin
export default {"TextAreaElementContainer":"TextAreaElement-module__TextAreaElementContainer--efGjO","codeViewTextArea":"TextAreaElement-module__codeViewTextArea--uyz8K"};